<template>
  <div class="cosmic-bg">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1920 1080"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="cosmicBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#e8edff" />
          <stop offset="50%" stop-color="#e0e7ff" />
          <stop offset="100%" stop-color="#eef2ff" />
        </linearGradient>

        <radialGradient id="amberGlow" cx="8%" cy="5%" r="40%">
          <stop offset="0%" stop-color="#d4a520" stop-opacity="0.14" />
          <stop offset="50%" stop-color="#b8941a" stop-opacity="0.05" />
          <stop offset="100%" stop-color="transparent" stop-opacity="0" />
        </radialGradient>

        <radialGradient id="tealGlow" cx="92%" cy="55%" r="38%">
          <stop offset="0%" stop-color="#0e9aa7" stop-opacity="0.12" />
          <stop offset="60%" stop-color="#0b7a8a" stop-opacity="0.04" />
          <stop offset="100%" stop-color="transparent" stop-opacity="0" />
        </radialGradient>

        <radialGradient id="pinkOrb" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#c850a0" stop-opacity="0.18" />
          <stop offset="50%" stop-color="#a04080" stop-opacity="0.06" />
          <stop offset="100%" stop-color="transparent" stop-opacity="0" />
        </radialGradient>

        <radialGradient id="indigoOrb" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#6366f1" stop-opacity="0.14" />
          <stop offset="60%" stop-color="#4f46e5" stop-opacity="0.04" />
          <stop offset="100%" stop-color="transparent" stop-opacity="0" />
        </radialGradient>
      </defs>

      <!-- Base -->
      <rect width="100%" height="100%" fill="url(#cosmicBg)" />
      <rect width="100%" height="100%" fill="url(#amberGlow)" />
      <rect width="100%" height="100%" fill="url(#tealGlow)" />

      <!-- Orbs -->
      <circle cx="200" cy="850" r="150" fill="url(#pinkOrb)" class="pulse-slow" />
      <circle cx="1650" cy="220" r="130" fill="url(#indigoOrb)" class="pulse-slow-alt" />

      <!-- ===== CROSSHAIRS ===== -->
      <g class="float-gentle" opacity="0.30" stroke="#6366f1" stroke-width="1.5" stroke-linecap="round">
        <line x1="300" y1="140" x2="300" y2="168" /><line x1="286" y1="154" x2="314" y2="154" />
      </g>
      <g class="float-gentle-alt" opacity="0.25" stroke="#818cf8" stroke-width="1.3" stroke-linecap="round">
        <line x1="1520" y1="190" x2="1520" y2="214" /><line x1="1508" y1="202" x2="1532" y2="202" />
      </g>
      <g class="float-gentle" opacity="0.20" stroke="#818cf8" stroke-width="1.2" stroke-linecap="round">
        <line x1="780" y1="890" x2="780" y2="912" /><line x1="769" y1="901" x2="791" y2="901" />
      </g>
      <g class="float-gentle-alt" opacity="0.22" stroke="#6366f1" stroke-width="1.2" stroke-linecap="round">
        <line x1="1760" y1="690" x2="1760" y2="712" /><line x1="1749" y1="701" x2="1771" y2="701" />
      </g>
      <g class="float-gentle" opacity="0.18" stroke="#a78bfa" stroke-width="1.2" stroke-linecap="round">
        <line x1="100" y1="320" x2="100" y2="342" /><line x1="89" y1="331" x2="111" y2="331" />
      </g>

      <!-- ===== X MARKS ===== -->
      <g opacity="0.22" stroke="#818cf8" stroke-width="1.5" stroke-linecap="round">
        <line x1="550" y1="290" x2="566" y2="306" /><line x1="566" y1="290" x2="550" y2="306" />
      </g>
      <g opacity="0.18" stroke="#a78bfa" stroke-width="1.3" stroke-linecap="round">
        <line x1="1280" y1="740" x2="1294" y2="754" /><line x1="1294" y1="740" x2="1280" y2="754" />
      </g>
      <g opacity="0.20" stroke="#818cf8" stroke-width="1.2" stroke-linecap="round">
        <line x1="140" y1="510" x2="154" y2="524" /><line x1="154" y1="510" x2="140" y2="524" />
      </g>
      <g opacity="0.16" stroke="#6366f1" stroke-width="1.2" stroke-linecap="round">
        <line x1="1850" y1="400" x2="1864" y2="414" /><line x1="1864" y1="400" x2="1850" y2="414" />
      </g>

      <!-- ===== CONSTELLATION LINES ===== -->
      <g opacity="0.22" stroke="#a5b4fc" stroke-width="1">
        <line x1="680" y1="110" x2="750" y2="75" />
        <line x1="750" y1="75" x2="830" y2="100" />
        <line x1="830" y1="100" x2="890" y2="65" />
        <circle cx="680" cy="110" r="3" fill="#a5b4fc" />
        <circle cx="750" cy="75" r="2.5" fill="#a5b4fc" />
        <circle cx="830" cy="100" r="3" fill="#a5b4fc" />
        <circle cx="890" cy="65" r="2.5" fill="#a5b4fc" />
      </g>
      <g opacity="0.18" stroke="#c4b5fd" stroke-width="0.9">
        <line x1="1380" y1="840" x2="1440" y2="815" />
        <line x1="1440" y1="815" x2="1490" y2="845" />
        <line x1="1490" y1="845" x2="1540" y2="820" />
        <circle cx="1380" cy="840" r="2.5" fill="#c4b5fd" />
        <circle cx="1440" cy="815" r="3" fill="#c4b5fd" />
        <circle cx="1490" cy="845" r="2.5" fill="#c4b5fd" />
        <circle cx="1540" cy="820" r="2" fill="#c4b5fd" />
      </g>

      <!-- ===== CONCENTRIC CIRCLES (slow spin) ===== -->
      <g class="spin-very-slow" opacity="0.20" transform-origin="170 420">
        <circle cx="170" cy="420" r="45" fill="none" stroke="#818cf8" stroke-width="1" />
        <circle cx="170" cy="420" r="30" fill="none" stroke="#818cf8" stroke-width="0.8" stroke-dasharray="4 4" />
        <circle cx="170" cy="420" r="16" fill="none" stroke="#818cf8" stroke-width="0.6" />
        <circle cx="170" cy="420" r="5" fill="#818cf8" fill-opacity="0.25" />
      </g>
      <g class="spin-very-slow-reverse" opacity="0.16" transform-origin="1740 560">
        <circle cx="1740" cy="560" r="38" fill="none" stroke="#67e8f9" stroke-width="0.9" />
        <circle cx="1740" cy="560" r="24" fill="none" stroke="#67e8f9" stroke-width="0.7" stroke-dasharray="3 3" />
        <circle cx="1740" cy="560" r="12" fill="none" stroke="#67e8f9" stroke-width="0.5" />
        <circle cx="1740" cy="560" r="4" fill="#67e8f9" fill-opacity="0.25" />
      </g>
      <g class="spin-very-slow" opacity="0.14" transform-origin="960 540">
        <circle cx="960" cy="540" r="32" fill="none" stroke="#a78bfa" stroke-width="0.7" />
        <circle cx="960" cy="540" r="20" fill="none" stroke="#a78bfa" stroke-width="0.5" stroke-dasharray="3 3" />
        <circle cx="960" cy="540" r="8" fill="none" stroke="#a78bfa" stroke-width="0.4" />
      </g>

      <!-- ===== DIAMONDS ===== -->
      <g class="float-gentle" opacity="0.25" transform="translate(1120, 170)">
        <path d="M0,-24 L16,0 L0,24 L-16,0 Z" fill="none" stroke="#6366f1" stroke-width="1.3" />
        <path d="M0,-12 L8,0 L0,12 L-8,0 Z" fill="#6366f1" fill-opacity="0.10" />
      </g>
      <g class="float-gentle-alt" opacity="0.20" transform="translate(360, 660)">
        <path d="M0,-20 L14,0 L0,20 L-14,0 Z" fill="none" stroke="#a78bfa" stroke-width="1.2" />
        <path d="M0,-10 L7,0 L0,10 L-7,0 Z" fill="#a78bfa" fill-opacity="0.10" />
      </g>
      <g class="float-gentle" opacity="0.18" transform="translate(1600, 800)">
        <path d="M0,-18 L12,0 L0,18 L-12,0 Z" fill="none" stroke="#818cf8" stroke-width="1" />
        <path d="M0,-9 L6,0 L0,9 L-6,0 Z" fill="#818cf8" fill-opacity="0.08" />
      </g>

      <!-- ===== DOT GRIDS ===== -->
      <g opacity="0.18" fill="#818cf8">
        <circle cx="1040" cy="490" r="2" /><circle cx="1054" cy="490" r="2" /><circle cx="1068" cy="490" r="2" /><circle cx="1082" cy="490" r="2" />
        <circle cx="1040" cy="504" r="2" /><circle cx="1054" cy="504" r="2" /><circle cx="1068" cy="504" r="2" /><circle cx="1082" cy="504" r="2" />
        <circle cx="1040" cy="518" r="2" /><circle cx="1054" cy="518" r="2" /><circle cx="1068" cy="518" r="2" /><circle cx="1082" cy="518" r="2" />
      </g>
      <g opacity="0.15" fill="#a5b4fc">
        <circle cx="470" cy="170" r="2" /><circle cx="484" cy="170" r="2" /><circle cx="498" cy="170" r="2" />
        <circle cx="470" cy="184" r="2" /><circle cx="484" cy="184" r="2" /><circle cx="498" cy="184" r="2" />
        <circle cx="470" cy="198" r="2" /><circle cx="484" cy="198" r="2" /><circle cx="498" cy="198" r="2" />
      </g>
      <g opacity="0.14" fill="#c4b5fd">
        <circle cx="1400" cy="350" r="2" /><circle cx="1414" cy="350" r="2" /><circle cx="1428" cy="350" r="2" />
        <circle cx="1400" cy="364" r="2" /><circle cx="1414" cy="364" r="2" /><circle cx="1428" cy="364" r="2" />
      </g>

      <!-- ===== WAVY CIRCLE (login reference) ===== -->
      <g opacity="0.18" class="float-gentle-alt">
        <circle cx="1810" cy="100" r="32" fill="none" stroke="#a78bfa" stroke-width="1.2" />
        <path d="M1784,100 Q1796,86 1808,100 Q1820,114 1832,100" fill="none" stroke="#a78bfa" stroke-width="1.3" />
      </g>

      <!-- ===== CHEVRONS ===== -->
      <g class="float-gentle" opacity="0.22" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path d="M1240,640 L1262,662 L1284,640" stroke="#0ea5e9" stroke-width="1.5" />
        <path d="M1240,655 L1262,677 L1284,655" stroke="#0ea5e9" stroke-width="1.1" />
        <path d="M1240,670 L1262,692 L1284,670" stroke="#0ea5e9" stroke-width="0.8" />
      </g>
      <g class="float-gentle-alt" opacity="0.20" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path d="M110,270 L132,292 L154,270" stroke="#6366f1" stroke-width="1.4" />
        <path d="M110,285 L132,307 L154,285" stroke="#6366f1" stroke-width="1" />
        <path d="M110,300 L132,322 L154,300" stroke="#6366f1" stroke-width="0.7" />
      </g>
      <g class="float-gentle" opacity="0.16" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path d="M640,550 L658,568 L676,550" stroke="#a78bfa" stroke-width="1.2" />
        <path d="M640,563 L658,581 L676,563" stroke="#a78bfa" stroke-width="0.8" />
      </g>

      <!-- ===== TRIANGLES ===== -->
      <g class="float-gentle-alt" opacity="0.20">
        <path d="M1780,420 L1810,374 L1840,420 Z" fill="none" stroke="#818cf8" stroke-width="1.2" />
        <path d="M1793,416 L1810,388 L1827,416 Z" fill="#818cf8" fill-opacity="0.08" />
      </g>
      <g class="float-gentle" opacity="0.18">
        <path d="M60,700 L90,654 L120,700 Z" fill="none" stroke="#a78bfa" stroke-width="1.2" />
        <path d="M73,696 L90,668 L107,696 Z" fill="#a78bfa" fill-opacity="0.08" />
      </g>
      <g class="float-gentle-alt" opacity="0.15">
        <path d="M1200,140 L1228,100 L1256,140 Z" fill="none" stroke="#67e8f9" stroke-width="1" />
        <path d="M1212,137 L1228,112 L1244,137 Z" fill="#67e8f9" fill-opacity="0.06" />
      </g>

      <!-- ===== ZIGZAGS ===== -->
      <g opacity="0.20" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path d="M570,730 L588,712 L606,730 L624,712 L642,730 L660,712 L678,730" stroke="#a5b4fc" stroke-width="1.3" />
      </g>
      <g opacity="0.16" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path d="M1090,340 L1108,322 L1126,340 L1144,322 L1162,340" stroke="#67e8f9" stroke-width="1.1" />
      </g>

      <!-- ===== DECORATIVE BORDER SEGMENTS ===== -->
      <g opacity="0.20">
        <line x1="440" y1="55" x2="610" y2="55" stroke="#818cf8" stroke-width="1.5" />
        <line x1="452" y1="64" x2="598" y2="64" stroke="#818cf8" stroke-width="0.9" />
        <rect x="468" y="42" width="13" height="13" fill="none" stroke="#818cf8" stroke-width="1.2" rx="2" />
        <rect x="492" y="42" width="13" height="13" fill="#818cf8" fill-opacity="0.15" rx="2" />
        <rect x="516" y="42" width="13" height="13" fill="none" stroke="#818cf8" stroke-width="1.2" rx="2" />
        <circle cx="550" cy="49" r="7" fill="none" stroke="#818cf8" stroke-width="1.2" />
        <circle cx="550" cy="49" r="3" fill="#818cf8" fill-opacity="0.20" />
        <circle cx="576" cy="49" r="7" fill="none" stroke="#818cf8" stroke-width="1.2" />
      </g>
      <g opacity="0.16">
        <line x1="1290" y1="420" x2="1460" y2="420" stroke="#67e8f9" stroke-width="1.3" />
        <line x1="1302" y1="429" x2="1448" y2="429" stroke="#67e8f9" stroke-width="0.8" />
        <circle cx="1325" cy="412" r="6" fill="none" stroke="#67e8f9" stroke-width="1" />
        <circle cx="1352" cy="412" r="6" fill="none" stroke="#67e8f9" stroke-width="1" />
        <circle cx="1352" cy="412" r="2.5" fill="#67e8f9" fill-opacity="0.20" />
        <rect x="1372" y="406" width="12" height="12" fill="none" stroke="#67e8f9" stroke-width="1" rx="2" />
        <rect x="1394" y="406" width="12" height="12" fill="#67e8f9" fill-opacity="0.12" rx="2" />
      </g>

      <!-- ===== TWINKLING DOTS ===== -->
      <g fill="#6366f1">
        <circle cx="400" cy="95" r="1.8" opacity="0.25" class="twinkle" />
        <circle cx="620" cy="440" r="2" opacity="0.22" class="twinkle-alt" />
        <circle cx="950" cy="240" r="1.5" opacity="0.20" class="twinkle" />
        <circle cx="1150" cy="690" r="1.8" opacity="0.22" class="twinkle-alt" />
        <circle cx="1560" cy="440" r="1.5" opacity="0.20" class="twinkle" />
        <circle cx="1810" cy="880" r="1.8" opacity="0.18" class="twinkle-alt" />
        <circle cx="80" cy="790" r="1.5" opacity="0.22" class="twinkle" />
        <circle cx="1360" cy="90" r="2" opacity="0.25" class="twinkle-alt" />
        <circle cx="680" cy="770" r="1.5" opacity="0.18" class="twinkle" />
        <circle cx="1890" cy="190" r="1.8" opacity="0.20" class="twinkle-alt" />
        <circle cx="500" cy="600" r="1.5" opacity="0.22" class="twinkle" />
        <circle cx="1100" cy="150" r="1.8" opacity="0.20" class="twinkle-alt" />
      </g>

      <!-- ===== ABSTRACT SHAPES (bottom-right, matching login) ===== -->
      <g opacity="0.08">
        <ellipse cx="1660" cy="960" rx="90" ry="40" fill="#818cf8" />
        <circle cx="1740" cy="925" r="28" fill="#a78bfa" />
        <ellipse cx="1580" cy="990" rx="55" ry="25" fill="#67e8f9" />
      </g>
    </svg>
  </div>
</template>

<script setup lang="ts">
// Purely decorative
</script>

<style scoped>
.cosmic-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
}

@keyframes floatGentle {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
@keyframes floatGentleAlt {
  0%, 100% { transform: translateY(0) translateX(0); }
  50% { transform: translateY(-5px) translateX(4px); }
}
.float-gentle { animation: floatGentle 8s ease-in-out infinite; }
.float-gentle-alt { animation: floatGentleAlt 10s ease-in-out infinite; }

@keyframes pulseSlow {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
.pulse-slow { animation: pulseSlow 7s ease-in-out infinite; }
.pulse-slow-alt { animation: pulseSlow 9s ease-in-out infinite 3s; }

@keyframes twinkle {
  0%, 100% { opacity: 0.08; }
  50% { opacity: 0.35; }
}
@keyframes twinkleAlt {
  0%, 100% { opacity: 0.10; }
  50% { opacity: 0.38; }
}
.twinkle { animation: twinkle 3.5s ease-in-out infinite; }
.twinkle-alt { animation: twinkleAlt 4.5s ease-in-out infinite 1.5s; }

@keyframes spinVerySlow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes spinVerySlowReverse {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}
.spin-very-slow { animation: spinVerySlow 120s linear infinite; }
.spin-very-slow-reverse { animation: spinVerySlowReverse 90s linear infinite; }
</style>
